import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {filterStyles} from '../shared/styles-filter';
import VirtualizedSelectInput from './VirtualizedSelectInput';

/**
 * A form containing a SelectInput component with Days Back choices
 *
 */
class DaysBackStoredFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDaysBack: props.daysBack
        };
        this.handleDaysBackChange = this.handleDaysBackChange.bind(this);
    }

    /**
     * Handle selection event for Days Back
     *
     * @param event
     * @param index
     * @param value
     */
    handleDaysBackChange(event, index, value) {
        let valueCheck = (index && index > 120) ? 120 : index;
        if (!valueCheck || valueCheck < 1) {
            valueCheck = 1;
        }

        if (index && index !== value) {
            this.setState({
                selectedDaysBack: valueCheck.toString()
            }, () => {
                this.props.dispatch(change('filterForm', this.props.reportName + '_days_back', valueCheck.toString()));
                this.props.onSelectDaysBack(this.state.selectedDaysBack);
            });
        }
    }

    createDateChoices(maxValue) {
        let choices = [];
        for (let i = 1; i <= maxValue; i++) {
            const choice = {id: i, name: i.toString()};
            choices.push(choice);
        }
        return choices;
    }

    render() {
        const {selectedDaysBack} = this.state;

        const styles = {
            button: {display: 'inline-block', margin: '0 0 0 0'},
            instructions: {fontSize: 12, margin: '1em 0 -1em 0'}
        };

        const choices = this.createDateChoices(120);

        return (
            <div className="list-filter">
                <form>
                    <div className="list-filter">
                        <div style={styles.instructions}>
                            Select a total of days back from today.
                        </div>
                        <Field name={`${this.props.reportName}_days_back`}
                               component={VirtualizedSelectInput}
                               choices={choices}
                               label=""
                               optionValue="id"
                               defaultValue={parseInt(selectedDaysBack, 10)}
                               allowEmpty
                               options={{
                                   clearable: false
                               }}
                               onChange={this.handleDaysBackChange}
                               elStyle={filterStyles.selectInputSmall}
                        />
                        <hr style={filterStyles.break}/>
                    </div>
                </form>
            </div>
        );
    }
}

DaysBackStoredFilter.propTypes = {
    addField: PropTypes.bool,
    basePath: PropTypes.string,
    daysBack: PropTypes.string,
    onSelectDaysBack: PropTypes.func,
    reportName: PropTypes.string,
    submitOnEnter: PropTypes.bool
};

DaysBackStoredFilter.defaultProps = {
    addField: true,
    daysBack: '30',
    reportName: 'recent',
    submitOnEnter: false
};

const enhance = compose(
    connect(),
    reduxForm({
        form: 'filterForm',
        enableReinitialize: true
    })
);

export default enhance(DaysBackStoredFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/DaysBackStoredFilter.js